import React, { useEffect, useRef, useState } from 'react'
import './leaderboard-landing-page.styles.scss';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import LeaderboardList from './leaderboard-list.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import CreateLeaderboard from './create-leaderboard.component';
import { getCollectionFromDb } from '@/utils/getDataFromDb';

const LeaderboardsLandingPage = ({ gameData, gameElements, playerList }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [leaderboardsFromDb, setLeaderboardsFromDb] = useState(null);
  const leaderboardsRef = useRef();
  let leaderboardsListener;

  useEffect(() => {

    return () => {
      if (leaderboardsListener) leaderboardsListener();
    }
  }, [])

  useEffect(() => {
    if (!gameData) return;
    getGameElementsToManage();
  }, [gameData])

  function cancel() {
    // if (location.pathname.endsWith('/leaderboards')) {
    //     navigate(`/manage/${gameData.path}`)
    // } else {
    navigate(-1);
    // }
  }

  function getGameElementsToManage() {
    getCollectionFromDb({
      "collection": `games/${gameData.gameId}/gameElements`,
      "query1": {
        "key": "type",
        "condition": "==",
        "value": "leaderboard"
      },
      "callback": callback,
      "handleListener": handleListener
    })
    function callback(data) {
      leaderboardsRef.current = {
        ...leaderboardsRef.current,
        ...{ [data.id]: data }
      }
      setLeaderboardsFromDb(leaderboardsRef.current);
    }
    function handleListener(data) {
      leaderboardsListener = data;
    }
  }

  return (
    <div className='manage-leaderboards-container'>

      <Routes>
        <Route path='' element={
          <div className='manage-leaderboards-content g-card'>
            <BackButton cancel={cancel} />
            <div className="g-space-1"></div>
            <div className='card-title'>
              <ImageContainer src='/images/icons/leaderboard.png' className='head-icon' />
              Create and Edit Leaderboards</div>
            <hr />
            <LeaderboardList
              gameElements={gameElements}
              leaderboardsFromDb={leaderboardsFromDb}
              gameData={gameData} />
          </div>
        }></Route>
        <Route path='create' element={
          <CreateLeaderboard
            gameData={gameData}
            gameElements={gameElements}
            leaderboardsFromDb={leaderboardsFromDb}
            playerList={playerList} />
        }></Route>
        <Route path='edit/:leaderboardId' element={
          <CreateLeaderboard
            gameData={gameData}
            gameElements={gameElements}
            leaderboardsFromDb={leaderboardsFromDb}
            playerList={playerList} />
        }></Route>
      </Routes>
    </div >
  )
}

export default LeaderboardsLandingPage